import { render, staticRenderFns } from "./faulthistory.vue?vue&type=template&id=a21112b2&scoped=true"
import script from "./faulthistory.vue?vue&type=script&lang=js"
export * from "./faulthistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21112b2",
  null
  
)

export default component.exports